export default __webpack_public_path__ + "static/media/164.3613aa6b.jpg";